/**
 * AONA Product Detail Page — aona-product.js
 * Handles PDP Image switching, pincode checking, quantity, variants, Add to Cart & Buy Now
 */

function aonaChangePdpImage(btn, newSrc) {
  var mainImg = document.getElementById('aona-pdp-main-img');
  if (mainImg) mainImg.src = newSrc;

  var thumbs = document.querySelectorAll('.aona-pdp-thumb-btn');
  thumbs.forEach(function (t) { t.classList.remove('is-active'); });
  if (btn) btn.classList.add('is-active');
}

function aonaUpdatePdpQty(delta) {
  var valEl = document.getElementById('aona-pdp-qty-val');
  var hiddenInput = document.getElementById('aona-pdp-selected-qty');
  var numInput = document.getElementById('aona-pdp-quantity');
  
  var current = 1;
  if (numInput && numInput.value) {
    current = parseInt(numInput.value, 10);
  } else if (valEl && valEl.textContent) {
    current = parseInt(valEl.textContent, 10);
  } else if (hiddenInput && hiddenInput.value) {
    current = parseInt(hiddenInput.value, 10);
  }
  if (isNaN(current) || current < 1) current = 1;
  
  var next = Math.max(1, current + delta);
  if (valEl) valEl.textContent = next;
  if (numInput) numInput.value = next;
  if (hiddenInput) hiddenInput.value = next;
}
window.aonaChangePdpQty = aonaUpdatePdpQty;

function aonaSelectSwatch(btn) {
  var parentGroup = btn.closest('.aona-pdp-option-group');
  if (parentGroup) {
    parentGroup.querySelectorAll('.aona-pdp-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    var labelVal = parentGroup.querySelector('.aona-pdp-option-selected');
    if (labelVal) labelVal.textContent = btn.getAttribute('data-value');
  }
  var selectedValues = [];
  document.querySelectorAll('.aona-pdp-swatches').forEach(function (swWrap) {
    var sel = swWrap.querySelector('.aona-pdp-swatch.is-selected');
    if (sel) selectedValues.push(sel.getAttribute('data-value'));
  });
  var dataEl = document.getElementById('aona-pdp-variants-data');
  if (dataEl) {
    try {
      var variants = JSON.parse(dataEl.textContent);
      var matched = variants.find(function (v) {
        return v.options.every(function (opt, idx) {
          return selectedValues[idx] === opt;
        });
      });
      if (matched) {
        var idInputs = document.querySelectorAll('#aona-pdp-selected-variant, #aona-pdp-selected-variant-id');
        idInputs.forEach(function (inp) { inp.value = matched.id; });
        var priceEl = document.querySelector('.aona-pdp-price');
        if (priceEl) priceEl.innerHTML = aonaFormatMoneyINR(matched.price);
        var mrpEl = document.querySelector('.aona-pdp-compare') || document.querySelector('.aona-pdp-mrp');
        var saveEl = document.querySelector('.aona-pdp-save');
        var discountBadge = document.getElementById('aona-pdp-discount-badge') || document.querySelector('.aona-pdp-discount-badge');

        if (mrpEl) {
          if (matched.compare_at_price > matched.price) {
            mrpEl.innerHTML = aonaFormatMoneyINR(matched.compare_at_price);
            mrpEl.style.display = 'inline';
            if (discountBadge) {
              var pct = Math.round(((matched.compare_at_price - matched.price) / matched.compare_at_price) * 100);
              discountBadge.textContent = pct + '% OFF';
              discountBadge.style.display = 'inline-block';
            }
            if (saveEl) {
              saveEl.textContent = 'Save ' + aonaFormatMoneyINR(matched.compare_at_price - matched.price);
              saveEl.style.display = 'inline';
            }
          } else {
            mrpEl.style.display = 'none';
            if (discountBadge) discountBadge.style.display = 'none';
            if (saveEl) saveEl.style.display = 'none';
          }
        }

        var stockBadge = document.getElementById('aona-pdp-stock-badge');
        if (stockBadge) {
          if (matched.available) {
            stockBadge.textContent = 'In Stock • Ready for Priority Dispatch';
            stockBadge.classList.remove('is-sold-out');
          } else {
            stockBadge.textContent = 'Sold Out • Handcrafting Soon';
            stockBadge.classList.add('is-sold-out');
          }
        }

        var atcBtn = document.getElementById('aona-pdp-atc-btn');
        var atcLabel = atcBtn ? atcBtn.querySelector('.aona-pdp-atc-label') : null;
        var buyNowBtn = document.getElementById('aona-pdp-buy-now-btn');
        if (atcBtn) {
          if (matched.available) {
            atcBtn.disabled = false;
            if (buyNowBtn) buyNowBtn.disabled = false;
            if (atcLabel) {
              atcLabel.textContent = 'ADD TO CART • ' + aonaFormatMoneyINR(matched.price);
            } else {
              atcBtn.textContent = 'Add to Cart';
            }
          } else {
            atcBtn.disabled = true;
            if (buyNowBtn) buyNowBtn.disabled = true;
            if (atcLabel) {
              atcLabel.textContent = 'SOLD OUT';
            } else {
              atcBtn.textContent = 'Sold Out';
            }
          }
        }
      }
    } catch (e) {
      console.warn('Swatch variant match error:', e);
    }
  }
}

function aonaFormatMoneyINR(val) {
  if (val === null || val === undefined || val === '') return '';
  // If string contains HTML (e.g. from currency app span), strip HTML
  if (typeof val === 'string' && val.indexOf('<') !== -1) {
    var div = document.createElement('div');
    div.innerHTML = val;
    val = div.textContent || div.innerText || '';
  }
  var cleanStr = String(val).replace(/[^0-9.]/g, '');
  if (!cleanStr) return String(val).trim();
  var num = Number(cleanStr);
  if (typeof val === 'number' || (String(val).indexOf('₹') === -1 && String(val).indexOf('.') === -1 && num >= 100)) {
    num = Math.round(num / 100);
  }
  return '₹ ' + num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function aonaSelectVariant(btn, variantId, priceRaw, compareRaw) {
  var pills = document.querySelectorAll('.aona-pdp-pill');
  pills.forEach(function (p) { p.classList.remove('is-active'); });
  if (btn) btn.classList.add('is-active');

  var idInput = document.getElementById('aona-pdp-selected-variant-id');
  if (idInput) idInput.value = variantId;

  var priceEl = document.querySelector('.aona-pdp-price');
  if (priceEl && priceRaw !== undefined && priceRaw !== null) {
    priceEl.innerHTML = aonaFormatMoneyINR(priceRaw);
  }

  var mrpEl = document.querySelector('.aona-pdp-mrp');
  var discountBadge = document.querySelector('.aona-pdp-discount-badge');
  if (mrpEl) {
    var pNum = Number(String(priceRaw).replace(/[^0-9.]/g, '')) || 0;
    var cNum = Number(String(compareRaw).replace(/[^0-9.]/g, '')) || 0;
    if (cNum > pNum && compareRaw) {
      mrpEl.innerHTML = aonaFormatMoneyINR(compareRaw);
      mrpEl.style.display = 'inline';
      if (discountBadge) {
        var pct = Math.round(((cNum - pNum) / cNum) * 100);
        discountBadge.textContent = pct + '% OFF';
        discountBadge.style.display = 'inline-block';
      }
    } else {
      mrpEl.style.display = 'none';
      if (discountBadge) discountBadge.style.display = 'none';
    }
  }
}

function aonaCheckPdpDelivery() {
  var input = document.getElementById('aona-pdp-pin-input');
  var resEl = document.getElementById('aona-pdp-pin-result');
  if (!input || !resEl) return;
  var val = input.value.trim();

  // 1. Indian 6-Digit PIN Code
  if (/^\d{6}$/.test(val)) {
    var d = new Date();
    d.setDate(d.getDate() + 4);
    var dateStr = d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
    resEl.textContent = '✔ Express Delivery by ' + dateStr + ' · 100% Insured Transit';
    resEl.className = 'aona-pdp-pin-result is-success';
    resEl.hidden = false;
    return;
  }

  // 2. Switzerland 4-Digit Postal Code (e.g. 8001 Zurich, 1201 Geneva)
  if (/^\d{4}$/.test(val)) {
    var d = new Date();
    d.setDate(d.getDate() + 6);
    var dateStr = d.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
    resEl.textContent = '✔ Express Air Delivery to Switzerland by ' + dateStr + ' · Customs Cleared';
    resEl.className = 'aona-pdp-pin-result is-success';
    resEl.hidden = false;
    return;
  }

  // 3. International Postal Code (US 5-digit, UK alphanumeric, Europe)
  if (/^(\d{5}|[a-zA-Z0-9\s\-]{3,10})$/.test(val) && val.length >= 3) {
    var d = new Date();
    d.setDate(d.getDate() + 7);
    var dateStr = d.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
    resEl.textContent = '✔ Worldwide Priority Air Delivery by ' + dateStr + ' · Fully Insured';
    resEl.className = 'aona-pdp-pin-result is-success';
    resEl.hidden = false;
    return;
  }

  resEl.textContent = 'Please enter a valid postal code or PIN code.';
  resEl.className = 'aona-pdp-pin-result is-error';
  resEl.hidden = false;
}

function aonaShowCartToast(msg, btnText, btnUrl) {
  var existing = document.getElementById('aona-global-cart-toast');
  if (existing) existing.remove();

  var toast = document.createElement('div');
  toast.id = 'aona-global-cart-toast';
  toast.innerHTML = '<div style="position: fixed; bottom: 30px; left: 50%; transform: translateX(-50%); background: #1C1610; color: #FAF7F2; padding: 14px 24px; border-radius: 8px; box-shadow: 0 10px 30px rgba(0,0,0,0.35); z-index: 999999; display: flex; align-items: center; gap: 16px; font-family: var(--aona-font-body, sans-serif); font-size: 1.4rem; border: 1px solid #854D0E;">' +
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>' +
    '<span>' + msg + '</span>' +
    (btnUrl ? '<a href="' + btnUrl + '" style="background: #854D0E; color: #FFF; padding: 6px 14px; border-radius: 4px; font-size: 1.2rem; font-weight: 700; text-decoration: none; letter-spacing: 0.05em; display: inline-block; margin-left: 8px;">' + (btnText || 'VIEW BAG') + '</a>' : '') +
    '</div>';
  document.body.appendChild(toast);
  setTimeout(function () {
    if (toast && toast.parentNode) toast.remove();
  }, 4500);
}

function updateAllCartBadges(count) {
  var badges = document.querySelectorAll('.aona-header-action-item span[style*="border-radius: 50%"], .cart-count-badge, .cart-count-bubble-sticky, .cart-count');
  badges.forEach(function (b) { b.textContent = count; });
}

function aonaAddToCartPDP(e) {
  if (e) e.preventDefault();
  var form = document.getElementById('aona-pdp-add-form') || document.getElementById('aona-pdp-form');
  var varInput = document.getElementById('aona-pdp-selected-variant-id') || document.getElementById('aona-pdp-selected-variant');
  var qtyInput = document.getElementById('aona-pdp-selected-qty') || document.getElementById('aona-pdp-quantity');
  var atcBtn = form ? (form.querySelector('.aona-pdp-btn-atc') || form.querySelector('.aona-pdp-btn-primary') || document.getElementById('aona-pdp-atc-btn')) : document.getElementById('aona-pdp-atc-btn');
  var atcLabel = atcBtn ? atcBtn.querySelector('.aona-pdp-atc-label') : null;

  var varId = varInput ? varInput.value : '';
  var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

  if (!varId) {
    if (form) form.submit();
    return;
  }

  var isAuth = (typeof window.aonaIsUserAuthenticated === 'function') ? window.aonaIsUserAuthenticated() : (window.aonaCustomerLoggedIn === true);
  if (!isAuth) {
    if (typeof window.aonaEnforceAuthAndRedirect === 'function') {
      window.aonaEnforceAuthAndRedirect(varId, qty, false);
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: varId, quantity: qty })
      }).finally(function() {
        window.location.href = '/account/login?checkout_url=' + encodeURIComponent('/cart') + '&return_to=' + encodeURIComponent('/cart');
      });
    }
    return;
  }

  var originalLabel = atcLabel ? atcLabel.textContent : (atcBtn ? atcBtn.textContent : 'ADD TO CART');
  if (atcBtn) {
    atcBtn.disabled = true;
    if (atcLabel) {
      atcLabel.textContent = 'ADDING TO BAG...';
    } else {
      atcBtn.textContent = 'Adding to Bag...';
    }
  }

  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  fetch(addUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: varId, quantity: qty })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart Add Failed');
      return res.json();
    })
    .then(function (cartItem) {
      if (atcBtn) {
        atcBtn.disabled = false;
        if (atcLabel) {
          atcLabel.textContent = '✓ ADDED TO BAG!';
        } else {
          atcBtn.textContent = '✓ Added to Bag!';
        }
        atcBtn.style.background = '#059669';
        setTimeout(function () {
          if (atcLabel) {
            atcLabel.textContent = originalLabel;
          } else {
            atcBtn.textContent = originalLabel;
          }
          atcBtn.style.background = '';
        }, 3000);
      }
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cartData) {
          updateAllCartBadges(cartData.item_count);
          aonaShowCartToast('Added to your Bag (' + cartData.item_count + ' items)', 'VIEW BAG', cartUrl);
        })
        .catch(function () {
          aonaShowCartToast('Added to your Bag!', 'VIEW BAG', cartUrl);
        });
    })
    .catch(function (err) {
      console.warn('AJAX Cart Add fallback:', err);
      if (atcBtn) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
      }
    });
}

function aonaBuyNowPDP(e) {
  if (e) e.preventDefault();
  var form = document.getElementById('aona-pdp-add-form') || document.getElementById('aona-pdp-form');
  var varInput = document.getElementById('aona-pdp-selected-variant-id') || document.getElementById('aona-pdp-selected-variant');
  var qtyInput = document.getElementById('aona-pdp-selected-qty') || document.getElementById('aona-pdp-quantity');
  var buyBtn = form ? form.querySelector('.aona-pdp-btn-secondary') : null;

  var varId = varInput ? varInput.value : '';
  var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

  if (!varId) {
    if (form) form.submit();
    return;
  }

  var isAuth = (typeof window.aonaIsUserAuthenticated === 'function') ? window.aonaIsUserAuthenticated() : (window.aonaCustomerLoggedIn === true);
  if (!isAuth) {
    if (typeof window.aonaEnforceAuthAndRedirect === 'function') {
      window.aonaEnforceAuthAndRedirect(varId, qty, true);
    } else {
      try {
        sessionStorage.setItem('aona_pending_buy_now', 'true');
        document.cookie = 'aona_buy_now=true; path=/; max-age=600; SameSite=Lax';
        sessionStorage.setItem('aona_pending_cart_action', JSON.stringify({ id: varId, quantity: qty, isBuyNow: true }));
      } catch(e) {}
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: varId, quantity: qty })
      }).finally(function() {
        window.location.href = '/account/login?checkout_url=' + encodeURIComponent('/checkout') + '&return_to=' + encodeURIComponent('/checkout');
      });
    }
    return;
  }

  if (buyBtn) {
    buyBtn.disabled = true;
    buyBtn.textContent = 'Preparing Checkout...';
  }

  fetch(addUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: varId, quantity: qty })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Buy Now Failed');
      return res.json();
    })
    .then(function (itemData) {
      // Detect international traffic (Switzerland, Europe, US, etc.)
      var isIntl = false;
      try {
        if (window.Shopify && window.Shopify.country && window.Shopify.country.toUpperCase() !== 'IN') isIntl = true;
        var offset = new Date().getTimezoneOffset();
        if (offset !== -330) isIntl = true;
        var tz = (Intl && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : '';
        if (tz && !tz.includes('Calcutta') && !tz.includes('Kolkata')) isIntl = true;
      } catch(e) {}

      var hasAddr = false;
      try {
        var rawAddr = localStorage.getItem('aona_shipping_address') || sessionStorage.getItem('aona_shipping_address');
        if (rawAddr) {
          var parsed = JSON.parse(rawAddr);
          if (parsed && parsed.address1 && parsed.zip) hasAddr = true;
        }
      } catch(e) {}

      if (!hasAddr && typeof window.aonaOpenAddressModal === 'function') {
        window.aonaOpenAddressModal(function(addr) {
          window.location.href = window.aonaGetCheckoutUrl ? window.aonaGetCheckoutUrl(addr) : '/checkout';
        });
      } else {
        window.location.href = window.aonaGetCheckoutUrl ? window.aonaGetCheckoutUrl() : '/checkout';
      }
    })
    .catch(function (err) {
      console.warn('Buy Now fallback to checkout:', err);
      window.location.href = window.aonaGetCheckoutUrl ? window.aonaGetCheckoutUrl() : '/checkout';
    });
}

// Attach listener to PDP form when DOM loads
document.addEventListener('DOMContentLoaded', function () {
  var pdpForm = document.getElementById('aona-pdp-add-form') || document.getElementById('aona-pdp-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', aonaAddToCartPDP);
  }

  // Handle all product card ATC buttons across grids
  document.querySelectorAll('.aona-card-atc-form').forEach(function (f) {
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var submitBtn = f.querySelector('.aona-card-btn-atc');
      var idInput = f.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) {
        f.submit();
        return;
      }
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Card ATC failed');
          return r.json();
        })
        .then(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = '✓ Added';
            setTimeout(function () {
              submitBtn.textContent = 'Add to Cart';
            }, 3000);
          }
          fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cData) {
              updateAllCartBadges(cData.item_count);
              aonaShowCartToast('Added to your Bag (' + cData.item_count + ' items)', 'VIEW BAG', cartUrl);
            })
            .catch(function () {
              aonaShowCartToast('Added to your Bag!', 'VIEW BAG', cartUrl);
            });
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Add to Cart';
          }
        });
    });
  });

  // Global PDP Hover Zoom initializer (supports both .aona-pdp-main-frame and .aona-pdp-main-img-wrap)
  (function initPdpImageHoverZoom() {
    var frames = document.querySelectorAll('.aona-pdp-main-frame, .aona-pdp-main-img-wrap');
    frames.forEach(function (frame) {
      var img = frame.querySelector('img');
      if (!img) return;

      var isHovering = false;

      frame.addEventListener('mouseenter', function () {
        if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
        isHovering = true;
        frame.classList.add('is-zoomed');
      });

      frame.addEventListener('mousemove', function (e) {
        if (!isHovering) return;
        var rect = frame.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));

        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(2.2)';
      });

      frame.addEventListener('mouseleave', function () {
        isHovering = false;
        frame.classList.remove('is-zoomed');
        img.style.transformOrigin = 'center center';
        img.style.transform = 'scale(1)';
      });
    });
  })();
});

